import React, { useRef } from 'react';
import clsx from 'clsx';

interface SearchBarProps {
    searchTerm: string;
    onSearchChange: (term: string) => void;
    results: number;
    placeholder?: string;
}

/**
 * Search input component for filtering the state tree
 * @param props - Component props
 * @returns Rendered component
 */
const SearchBar: React.FC<SearchBarProps> = ({
    searchTerm,
    onSearchChange,
    results,
    placeholder = 'Search state...',
}) => {
    const searchRef = useRef<HTMLInputElement>(null);

    const handleClear = (): void => {
        onSearchChange('');
        // Focus the input after clearing
        if (searchRef.current) {
            searchRef.current.focus();
        }
    };

    return (
        <div className="sticky top-0 z-10 bg-white p-2 shadow-xs">
            <div className="flex items-center rounded-sm border border-gray-300 bg-white px-2">
                <input
                    ref={searchRef}
                    type="text"
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    placeholder={placeholder}
                    className="w-full flex-1 py-1 outline-hidden"
                    autoComplete="off"
                />
                {searchTerm && (
                    <button
                        onClick={handleClear}
                        className="ml-1 rounded-full p-1 hover:bg-gray-100"
                        title="Clear search"
                    >
                        ✕
                    </button>
                )}
            </div>

            {searchTerm && (
                <div
                    className={clsx(
                        'mt-1 text-xs',
                        results > 0 ? 'text-green-600' : 'text-gray-500',
                    )}
                >
                    {results > 0
                        ? `Found ${results} match${results !== 1 ? 'es' : ''}`
                        : 'No matches found'}
                </div>
            )}
        </div>
    );
};

export default SearchBar;
